import React from 'react';
import styled from 'styled-components';
import { TextElem } from '../../../common/text';
import { Spacing } from '../../../theme';
import {
  VALUE_TRANSITION_DATA,
  VALUE_TRANSITION_ENUM,
  VALUE_OPACITY_DATA,
  VALUE_OPACITY_ENUM,
} from '../../../theme/value';

import {
  SIZE_BORDER_RADIUS_DATA,
  SIZE_BORDER_RADIUS_ENUM,
} from '../../../theme/size';
import imgPlaceholder from '../../../asset/svg/common/img-placeholder.svg';
import { COLOR_ENUM } from '../../../theme/color';
import { POPUP_ITEM_DATA_INTER, POPUP_STATUS } from '../constant';
import { PopupItemUpdateContainer } from '../../popup-item-update';

export const Card: React.FC<{
  data: POPUP_ITEM_DATA_INTER;
  isOpen: boolean;
  onClick: () => void;
}> = ({ data, isOpen, onClick }) => {
  const handleClose = () => {
    onClick();
  };
  return (
    <>
      {!isOpen && (
        <>
          <Container
            className="user_container"
            isOpen={isOpen}
            onClick={onClick}
          >
            <ImgStyled src={data.imgUrl ? data.imgUrl : imgPlaceholder} />
            <InfoContainer>
              <TextElem
                size="semiSmall"
                color="white"
                type="semi-bold"
                tid={data.body}
                oneLine
              />
              <InfoList>
                <TextElem
                  color="textPrimary"
                  size="verySmall"
                  type="medium"
                  tid={data.deadlineView}
                />
                <Dot />
                <TextElem
                  color={
                    data.status[0]?.value === POPUP_STATUS.ACTIVE
                      ? 'tag'
                      : 'tagSecondary'
                  }
                  size="verySmall"
                  type="medium"
                  tid={data.status[0]?.label}
                />
              </InfoList>
            </InfoContainer>
          </Container>
        </>
      )}

      {isOpen && (
        <PopupItemUpdateContainer onSuccess={handleClose} data={data} />
      )}
    </>
  );
};

const ImgStyled = styled.img`
  height: 40px;
  width: 70px;
  border-radius: ${SIZE_BORDER_RADIUS_DATA[SIZE_BORDER_RADIUS_ENUM.TAG]}px;
`;

const Dot = styled.div`
  width: 3px;
  height: 3px;
  border-radius: ${SIZE_BORDER_RADIUS_DATA[SIZE_BORDER_RADIUS_ENUM.CIRCLE]}px;
  background-color: ${({ theme }) => theme[COLOR_ENUM.DOT]};
`;

const InfoList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${Spacing(1)};
  align-items: center;
`;

const InfoContainer = styled.div`
  display: flex;
  text-align: start;
  flex-direction: column;
  gap: 6px;
  overflow: hidden;
`;

const Container = styled.div<{ isOpen: boolean }>`
  width: 100%;
  display: grid;
  grid-template-columns: 70px auto;
  grid-gap: ${Spacing(2)};
  align-items: center;
  position: relative;
  cursor: pointer;
  justify-content: start;
  transition: opacity ${VALUE_TRANSITION_DATA[VALUE_TRANSITION_ENUM.HOVER]};

  &:hover {
    opacity: ${VALUE_OPACITY_DATA[VALUE_OPACITY_ENUM.HOVER]};
  }
`;
